<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 19 17">
    <path
      d="M15.6014 1.0625V0H12.4249V1.0625H7.13077V0H3.9543V1.0625H0.777832V17H18.7778V1.0625H15.6014ZM13.4837 1.0625H14.5425V3.1875H13.4837V1.0625ZM5.01313 1.0625H6.07195V3.1875H5.01313V1.0625ZM17.719 15.9375H1.83666V6.46H17.719V15.9375ZM1.83666 5.3975V2.125H3.9543V4.25H7.13077V2.125H12.4249V4.25H15.6014V2.125H17.719V5.3975H1.83666Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
